import React from 'react';
import t from '@rcm/i18n-client';
import { ImSpinner } from 'react-icons/im';
import './LoadingSpinner.scss';
import { Col, Row } from 'react-bootstrap';

interface Props {
    text?: string;
    className?: string;
}

const LoadingSpinner = (props: Props) => {
    return <Row className={`m-3 ${props.className}`}>
        <Col>
            <ImSpinner className="loading-spinner" />&nbsp;<em>{props.text ?? t('Loading...')}</em>
        </Col>
    </Row>;
};

export default LoadingSpinner;
